import { BlogMenuProps } from './BlogMenu';
import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { CloseIcon, MenuIcon } from 'public/svg/IconsSvg';
import { twJoin } from 'tailwind-merge';

const TEST_IDENTIFIER = 'blocks-blog-menu-category-';

type BlogMenuItemProps = BlogMenuProps & {
    isMobileView: boolean;
    isCollapsed: boolean;
};

export const BlogMenuItem: FC<BlogMenuItemProps> = ({
    items,
    level = 0,
    activeItemUuid,
    isMobileView,
    isCollapsed,
}) => {
    return (
        <>
            {items !== undefined && items.length > 0 && (
                <ul data-testid={TEST_IDENTIFIER + level}>
                    {items.map(({ uuid, name, link, children, onClick }, index) => (
                        <li key={uuid}>
                            <ExtendedNextLink
                                onClick={onClick}
                                shouldRedirectOnClick={!onClick}
                                type="blogCategory"
                                href={link}
                                style={{
                                    paddingLeft: `${30 + level * 20}px`,
                                }}
                                className={twJoin(
                                    'flex justify-between border-b border-solid border-borderLight py-4 px-7 text-small leading-5 tracking-wider no-underline duration-200 ease-defaultTransition lg:text-body',
                                    'hover:no-underline md:hover:text-white',
                                    level === 0 && 'font-bold lg:font-medium',
                                    uuid === activeItemUuid
                                        ? 'bg-grayVeryDark text-white md:hover:bg-grayDark'
                                        : 'bg-transparent  text-primary md:hover:bg-primary',
                                )}
                            >
                                <>
                                    {name}
                                    {isMobileView &&
                                        level === 0 &&
                                        index === 0 &&
                                        (isCollapsed ? (
                                            <MenuIcon className="h-4 w-4" />
                                        ) : (
                                            <CloseIcon className="h-3 w-3" />
                                        ))}
                                </>
                            </ExtendedNextLink>

                            {(children ?? []).length > 0 && (
                                <BlogMenuItem
                                    items={children}
                                    level={level + 1}
                                    activeItemUuid={activeItemUuid}
                                    isMobileView={isMobileView}
                                    isCollapsed={isCollapsed}
                                />
                            )}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};
